








import { Component } from "vue-property-decorator";
import OverviewMixin from "@/mixins/admin/overviewMixin";

@Component({
  components: {
    "promotion-uses-table": () =>
      import(
        "@/components/app/admin/catalogue/promotions/promotionUsesTable.vue"
      )
  }
})
export default class PromotionUsesView extends OverviewMixin {
  // Override OverviewMixin
  public get tableId() {
    return "PU1";
  }

  public get promotionId() {
    return this.$route.params.promotionId;
  }
}
